export default "__VITE_ASSET__DUJ_JIOm__"